import { DownloadRefusal } from '@/lib/download-protection/refusals'

type DownloadProtectionAnalyticsEvent =
  | 'download_protection_refusal_presented'
  | 'download_protection_delay_elapsed'
  | 'download_protection_challenge_completed'
  | 'download_protection_challenge_failed'
  | 'download_protection_upsell_answered'

type DownloadProtectionAnalyticsPayload = {
  refusal_code?: DownloadRefusal['code']
  can_retry?: boolean
  outcome?: 'clicked' | 'dismissed'
  reason?: 'error' | 'expired' | 'render_error' | 'retry_error' | 'unconfigured'
}

/**
 * Sends download-protection funnel events through the site's analytics session.
 *
 * Refusals can carry administrator-authored messages, destination URLs, and penalty ids.
 * None belongs in analytics, so callers only send the small, enumerated fields above.
 */
export function sendDownloadProtectionEvent(
  event: DownloadProtectionAnalyticsEvent,
  payload: DownloadProtectionAnalyticsPayload = {}
) {
  if (typeof window === 'undefined') {
    return
  }

  const send = window.getGlobalSession?.()?.analytics?.sendCustomEvent

  if (typeof send !== 'function') {
    return
  }

  try {
    send(event, payload)
  } catch (error) {
    console.debug('download-protection analytics event failed', { event, payload, error })
  }
}
